<template>
	<div class="webContent flex">
		<div class="release df cf">
			<div class="title">
				<textarea puc placeholder="输入标题" v-model="title">{{title}}</textarea>
			</div>
			<div class="list flex">
				<div class="info">请上传PDF/图片/视频格式，视频控制在20s且50m以内</div>
				<img :src="file" alt="" v-if="type=='img'" />
				<video controls="controls" :src="file" v-else-if="type=='video'"></video>
				<div v-else-if="type=='pdf'">PDF文件：{{file}}</div>
			</div>
			<div class="tool df hao">
				<div class="btn flex"><input type="file" accept="*" @change="toUpload($event.currentTarget)" />上传文件</div>
				<div class="btn btn2 flex" @click="submitRelease">发布</div>
			</div>
		</div>
	</div>
</template>

<script>
	import h5PublicApi from '../../../script/public.js'

	export default {
		name: 'material_upload_page',
		data () {
			return {
				title: '',
				type: '',
				file: '',
			}
		},
		methods: {
			changeModelReleasePrivate(state){
				console.log(state);
			},
			submitRelease(){
				console.log('点击了发布');
				// this.$router.go(-1);
				h5PublicApi.jumpRecard(true);
			},
			toUpload(obj){
				var fval = obj.value;
				var file = obj.files;
				if(file.length==0){
					return;
				}

				var fileType = '';
				if(/.(jpg|jpeg|png)$/.test(fval.toLowerCase())){
					fileType = 'img';
					this.toUploadPhoto(obj);
				}else if(/.(mpeg|avi|mov|3gp|mp4|wmv|mkv|m3u8)$/.test(fval.toLowerCase())){
					fileType = 'video';
					this.toUploadVideo(obj);
				}else if(/.pdf$/.test(fval.toLowerCase())){
					fileType = 'pdf';
					this.type = 'pdf';
					this.file = fval;
				}else{
					alert('此类型的文件暂不支持');
				}
			},
			toUploadPhoto(obj){
				var that = this;
				var img = obj.value;
				var file = obj.files;

				var fileSize = file[0].size; // kb

				if(fileSize>5*1024*1000){
					alert('图片大小不能超过5M');
					return;
				}

				var reader = new FileReader();
				// reader.readAsDataURL(file[0]);
				// reader.onload = function(hFile){
				// 	var imgData = new Image();
				// 	imgData.src = hFile.target.result;
				// 	imgData.onload = function(){
				// 		console.log(this.width);
				// 		console.log(this.height);

				// 		var html = '<div><img style="max-width: 100%;" src="'+require('@/app/assets/load.gif')+'" /></div>';
				// 		that.$refs.editTextarea.insertData(html);
				// 		console.log(file,img);
				// 	}
				// }
				reader.readAsArrayBuffer(file[0]);
				reader.onload = function(){
					var bf = this.result;
					var blob = new Blob([bf],{type:"text/plain"});

					// var html = '<div><img style="max-width: 100%;" src="'+URL.createObjectURL(blob)+'" /></div>';
					// that.$refs.editTextarea.insertData(html);
					that.type = 'img';
					that.file = URL.createObjectURL(blob);
				}
			},
			toUploadVideo(obj){
				var that = this;
				var video = obj.value;
				var file = obj.files;

				var fileSize = file[0].size; // kb

				if(fileSize>50*1024*1000){
					alert('视频大小不能超过50M');
					return;
				}

				var videoData = URL.createObjectURL(new Blob([file[0]], {type: "application/zip"}));
				var audioElement = new Audio(videoData);
				audioElement.addEventListener("loadedmetadata", function (_event) {
					if(Math.floor(audioElement.duration)>20){
						alert('视频长度不能超过20秒');
						return;
					}

					// var html = '<div><video controls="controls" style="width: 100%;" src="'+videoData+'"></video></div>';
					// that.$refs.editTextarea.insertData(html);
					that.type = 'video';
					that.file = videoData;

					console.log(file,video);
				});
			},
		},
	}
</script>

<style scoped>
	@import './upload'
</style>



// WEBPACK FOOTER //
// src/app/pages/material/upload/upload.vue